module.exports = __webpack_public_path__ + "img/personal_details_blue.4aaf4886.svg";